import './comments-button.css';

interface CommentsButtonProps {
  onClick: () => void;
}

export const CommentsButton = ({ onClick }: CommentsButtonProps) => {
  return (
    <button
      className="icon comments-button"
      onClick={onClick}
      aria-label="Toggle comments panel"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
      </svg>
    </button>
  );
};
